import { createSlice } from "@reduxjs/toolkit";
import { getHomeBanner, updateHomeBanner } from "actions/homeBanner";

const initialState = {
  homeBanner: null,
  loading: false,
  updateLoading: false,
  error: null,
};

const homeBannerSlice = createSlice({
  name: "homeBanner",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearHomeBanner: (state) => {
      state.homeBanner = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getHomeBanner.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getHomeBanner.fulfilled, (state, action) => {
        state.loading = false;
        state.homeBanner = action.payload;
      })
      .addCase(getHomeBanner.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });

    builder
      .addCase(updateHomeBanner.pending, (state) => {
        state.updateLoading = true;
        state.error = null;
      })
      .addCase(updateHomeBanner.fulfilled, (state, action) => {
        state.updateLoading = false;
        state.homeBanner = action.payload;
      })
      .addCase(updateHomeBanner.rejected, (state, action) => {
        state.updateLoading = false;
        state.error = action.error.message;
      });
  },
});

export const { clearError, clearHomeBanner } = homeBannerSlice.actions;
export default homeBannerSlice.reducer;
